import React from 'reactn';
import useMemberPprs from './useMemberPprs';
import get from 'lodash/get';

export default function useMyPprs({ period, memberId }) {

  const fromDate = React.useMemo(() => {
    if (period) return new Date(period.dateFrom);
    return new Date();
  }, [period]);

  const { periodMap, periods } = useMemberPprs({ id: memberId, fromDate });

  const { lastWeekPpr, ppr } = React.useMemo(() => {
    if (!periods || !periodMap) return {};
    const selectedPeriodId = period.id;
    let lastWeekPpr, ppr;
    periods.some((p, ii) => {
      if (p.id === selectedPeriodId) {
        ppr = get(periodMap, [p.id, '0']);
        const lastWeekPprId = get(periods, [ii + 1, 'id']);
        if (lastWeekPprId) {
          lastWeekPpr = get(periodMap, [lastWeekPprId, '0']);
        }
        return true;
      }
    });
    return { lastWeekPpr, ppr };
  }, [periodMap, periods, period.id]);

  return { lastWeekPpr, ppr };
}
